// ClientNotesCard — Phase S1 sidebar presentation card.
//
// Pure render. Receives the parent-loaded `client` snapshot and edit
// affordance state via props. No fetch, no dispatch, no selector, no
// internal state, no orchestration. Per CLAUDE.md "Presentation
// Primitive Rules": prop-driven, selector-free, dispatch-free,
// ownership-agnostic. Sidebar peer of [[ClientStampsCard]].
//
// Phase S15 — continuation-seam normalization. The edit affordance
// previously routed to the R7 §5.3 transitional /edit URL; every
// other dossier CRUD affordance has since become a feature-local
// modal trigger. The notes card now consumes the parent-owned
// ClientEditModal via the `onEditRequest` callback prop — the same
// modal the parent header's "Редагувати" button opens. Design-
// faithful (clientDetail.html uses one `#cd-edit-modal` triggered
// from both header and notes card) and restores narrative
// continuity: clicking notes edit no longer warps the user out of
// the dossier topology.

function ClientNotesCard({ client, onEditRequest }) {
  if (!client) return null;
  const canEdit = client.can_edit !== false;
  const hasNotes =
    typeof client.notes === "string" && client.notes.trim().length > 0;

  return (
    <article
      className="cd-card"
      aria-labelledby="client-detail-notes-heading"
    >
      <header className="cd-card__head">
        <h3 id="client-detail-notes-heading">
          <i className="fa-solid fa-note-sticky" aria-hidden="true" />
          <span>Внутрішні нотатки</span>
        </h3>
        {canEdit && typeof onEditRequest === "function" ? (
          <button
            type="button"
            onClick={onEditRequest}
            className="cd-section__edit"
            aria-label="Редагувати нотатки"
          >
            <i className="fa-solid fa-pen-to-square" aria-hidden="true" />
          </button>
        ) : null}
      </header>
      {hasNotes ? (
        <p className="cd-card__text">{client.notes}</p>
      ) : (
        <p className="cd-card__text feature-client-detail__cd-card-text--muted">
          Немає нотаток.
        </p>
      )}
    </article>
  );
}

export default ClientNotesCard;
